// eslint-disable-next-line default-param-last
export const trackGA4 = (event = 'track-event', payload) => {
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event,
      ...payload
    });
  }
};
